const FETCH_CONFERENCES_INITIATED = 'FETCH_CONFERENCES_INITIATED';
const FETCH_CONFERENCES_SUCCEEDED = 'FETCH_CONFERENCES_SUCCEEDED';
const FETCH_CONFERENCES_FAILED = 'FETCH_CONFERENCES_FAILED';

export default {
  FETCH_CONFERENCES_INITIATED,
  FETCH_CONFERENCES_SUCCEEDED,
  FETCH_CONFERENCES_FAILED,
};
